export default __webpack_public_path__ + "static/media/Join_Interview.ebbb8256.svg";